
import * as Inovx from '@shared';
import assign from 'object-assign';
import { apiPostForm } from '@shared/api/apiClient';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var DateTimeOffsetHelper = Inovx.Shared.Common.DateTimeOffsetHelper;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/View360`;

const appendViewItem = (formData: FormData, item: IView360Identity, index: number) => {
    formData.append(`Items[${index}].ID`, item.ID);
    formData.append(`Items[${index}].VersionToken`, item.VersionToken);
};

const appendNumber = (formData: FormData, key: string, value?: number | null) => {
    if (value != null) {
        formData.append(key, value.toString());
    }
};

const appendBoolean = (formData: FormData, key: string, value?: boolean) => {
    if (value != null) {
        formData.append(key, value.toString());
    }
};

var View360Services: IView360Services = assign({}, Inovx.Shared.Flux.BaseService, {    
    getView360: function (id: string) {
        return new Promise<IView360>((resolve, reject) => {
            this.get(`${url}/ById`,
                { id },
                (retData: IView360) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    updateMetadata: async function (update: IView360MetadataUpdate) {
        const formData = new FormData();

        formData.append('ID', update.ID);
        formData.append('VersionToken', update.VersionToken);
        formData.append('clientTime', DateTimeOffsetHelper.getCurrentDatetimeWithOffset());
        appendNumber(formData, 'North', update.North);
        appendNumber(formData, 'East', update.East);
        appendNumber(formData, 'Up', update.Up);
        appendNumber(formData, 'Angle', update.Angle);
        appendBoolean(formData, 'ClearAngle', update.ClearAngle);

        try {
            return await apiPostForm<IView360MutationResult>(`${url}/UpdateMetadata`, formData, { responseType: 'json' });
        }
        catch (error) {
            this.handleWebApiError(error);
            throw error;
        }
    },
    updateMetadataBatch: async function (update: IView360BatchMetadataUpdate) {
        const formData = new FormData();

        update.Items.forEach((item, index) => appendViewItem(formData, item, index));
        formData.append('clientTime', DateTimeOffsetHelper.getCurrentDatetimeWithOffset());
        appendNumber(formData, 'Up', update.Up);
        appendNumber(formData, 'Angle', update.Angle);
        appendBoolean(formData, 'ClearAngle', update.ClearAngle);
        appendNumber(formData, 'PanoColorType', update.PanoColorType);

        try {
            await apiPostForm<void>(`${url}/UpdateMetadataBatch`, formData, { responseType: 'none' });
        }
        catch (error) {
            this.handleWebApiError(error);
            throw error;
        }
    },
    deleteMany: async function (items: IView360Identity[]) {
        const formData = new FormData();

        items.forEach((item, index) => appendViewItem(formData, item, index));
        formData.append('clientTime', DateTimeOffsetHelper.getCurrentDatetimeWithOffset());

        try {
            await apiPostForm<void>(`${url}/DeleteMany`, formData, { responseType: 'none' });
        }
        catch (error) {
            this.handleWebApiError(error);
            throw error;
        }
    },
});

export default View360Services;
